import {NgModule} from "@angular/core";
import {OrgUserProfileModalComponent} from "./org-user-profile-modal.component";
import {ButtonModule, TooltipModule as XrefTooltipModule} from '@xref/xref-lib';
import {CommonModule} from "@angular/common";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule(
  {
    declarations: [OrgUserProfileModalComponent],
    imports: [XrefTooltipModule,
      CommonModule,
      NgSelectModule,
      ButtonModule
    ],
    exports: []
  }
)
export class OrgUserProfileModalModule {
}
